import { DEFAULT_LOCATIONS, SOCT, DROPDOWN } from 'utils/constants';
import { selectToken, EnvTokenMap } from 'utils/selectToken';
import { IndividualLocalClientConfig } from './localConfig.types';

export const apiTokens: EnvTokenMap = {
  dev: 'Token 7aa95f2dd343a8084d6d3203f143d83bbca28149',
  staging: 'Token 321527ba2c48504d40befa570180680db1e18566',
  prod: 'Token 50522284abbed9c05b2a2f676aa3953883c35b41',
};

const token = selectToken(apiTokens);

const soctConfig: IndividualLocalClientConfig = {
  // config name used for fetching client config from fusion
  CONFIG_NAME: 'carecompass',

  API_TOKEN: token,
  EMBOLD_CLIENT: SOCT,

  // login
  SHOW_REGION_SELECTOR: true,
  NETWORKS: {},
  HIGH_QUALITY_INTRO_MODAL: false,

  // other
  DEFAULT_LOCATION: { ...DEFAULT_LOCATIONS.Hartford },
  LOGIN_NETWORK_NAME: 'soctUserId',

  // content
  DISPLAY_NAME: 'State of Connecticut',
  FORM_VARIANT: DROPDOWN,
  NO_WELCOME_LINK: false,
};

export default soctConfig;
